import { render } from "./TheSpeechManager.vue?vue&type=template&id=adb00ad2"
import script from "./TheSpeechManager.vue?vue&type=script&lang=js"
export * from "./TheSpeechManager.vue?vue&type=script&lang=js"
script.render = render

export default script